<ng-container>
  <div *ngIf="!isDoctorVerifiedKit" class="tw-bg-white tw-mx-4 tw-rounded-[15px] tw-shadow-z4 tw-mt-2">
    <div class="tw-px-4 tw-py-6 tw-bg-orange-75 tw-rounded-t-[15px]" [ngClass]="{'tw-rounded-b-[15px]': !isAppLanguageEnglish}">
      <div class="tw-flex tw-gap-2 tw-mb-4">
        <div class="tw-flex-none">
          <div class="tw-relative tw-w-20 tw-aspect-square tw-flex tw-justify-center tw-items-center">
            <img class="tw-rounded-full tw-absolute tw-inset-0 tw-w-full tw-h-full" src="/assets/images/voice_note.gif" />
            <img class="tw-rounded-full tw-absolute tw-w-16 tw-aspect-square" [src]="docImg" />
            <img src="/assets/gifs/blinking-red-dot.gif" alt="red-blink-circle"
                 class="tw-w-[10px] tw-aspect-square tw-absolute tw-top-[14px] tw-right-[10px]"/>
          </div>
        </div>
        <div class="tw-pt-2">
          <h1 class="tw-text-400 tw-font-bold tw-mb-2" i18n="@@newVoiceMsg">
            1 new voice message
          </h1>
          <p *ngIf="message.length" class="tw-line-clamp-2 tw-text-200 tw-text-gray-500 tw-pr-[18%]">
            {{message}}
          </p>
          <p *ngIf="!message.length" class="tw-line-clamp-2 tw-text-200 tw-text-gray-500 tw-pr-[18%]" i18n="@@drSharedMessage">
            Your doctor has shared a message regarding your treatment.
          </p>
        </div>
      </div>
      <app-custom-audio-waveform [voiceUrl]="voiceUrl" (emitTrackEvent)="handleClick($event)"></app-custom-audio-waveform>
    </div>
    <ng-container *ngTemplateOutlet="languageStrip"></ng-container>
  </div>
  <!--  new voice note UI Doctor verified kit card  -->
  <div *ngIf="isDoctorVerifiedKit" class="tw-bg-white tw-mx-4 tw-rounded-[15px] tw-shadow-z4 tw-mt-2">
    <div class="tw-bg-orange-75 tw-px-4 tw-flex tw-items-center tw-gap-2 tw-h-10 tw-rounded-t-[15px]">
      <h1 class="tw-text-400 tw-font-bold tw-font-body" i18n="@@drVerified">Doctor verified</h1>
      <img alt="icon" src="/assets/icons/orange_tick_new.svg" class="tw-w-4 tw-aspect-square" id="tick">
    </div>
    <div class="tw-bg-orange-75 tw-px-4">
      <div class="tw-h-px tw-bg-gray-300 tw-opacity-50 "></div>
    </div>
    <div class="tw-p-4 tw-pt-3 tw-bg-orange-75" [ngClass]="{'tw-rounded-b-[15px]': !isAppLanguageEnglish}">
      <div class="tw-flex tw-gap-2 tw-items-center tw-mb-3">
        <div class="tw-flex-none">
          <div class="tw-w-16 tw-aspect-square tw-flex tw-justify-center tw-items-center">
            <img class="tw-rounded-full tw-w-16 tw-aspect-square" [ngClass]="regimenCoverBgColor" [src]="kitImageUrl" />
          </div>
        </div>
        <p class="tw-text-gray-500 tw-font-body tw-font-medium tw-text-300" i18n="@@drHasVerifiedYourTreatmentKit">
          {{doctorName}} has verified your treatment kit
        </p>
      </div>
      <app-custom-audio-waveform [voiceUrl]="voiceUrl" [isDoctorImageVariant]="isDoctorVerifiedKit" [docImg]="docImg" [regimen]="regimen" (emitTrackEvent)="handleClick($event)"></app-custom-audio-waveform>
    </div>
    <ng-container *ngTemplateOutlet="languageStrip"></ng-container>
  </div>
</ng-container>

<!-- Language strip states shared between both card variants -->
<ng-template #languageStrip>
  <!-- EN/HI updated state -->
  <div *ngIf="isAppLanguageEnglish && languageUpdatedDisplayName && isEnHiLanguageUpdate"
       class="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3 tw-bg-white tw-rounded-b-[15px]">
    <span class="tw-text-300 tw-text-gray-500 tw-font-body" i18n="@@voiceNoteLanguage">Voice note language</span>
    <div class="tw-flex tw-items-center tw-gap-1">
      <span class="tw-font-body tw-text-200 tw-font-bold tw-text-teal-600" i18n="@@voiceNoteUpdatedTo">updated to {{languageUpdatedDisplayName}}</span>
      <cs-icon class="tw-h-4 tw-w-4 tw-text-teal-600" iconName="done"></cs-icon>
    </div>
  </div>
  <!-- TE/MR updated state -->
  <div *ngIf="isAppLanguageEnglish && languageUpdatedDisplayName && !isEnHiLanguageUpdate"
       class="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3 tw-bg-white tw-rounded-b-[15px]">
    <div class="tw-flex tw-items-center tw-gap-1">
      <cs-icon class="tw-h-4 tw-w-4 tw-text-teal-600" iconName="done"></cs-icon>
      <span class="tw-font-body tw-text-200 tw-text-teal-600" i18n="@@futureVoiceNotesIn">Future voice notes will be in {{languageUpdatedDisplayName}}</span>
    </div>
    <span class="tw-font-body tw-text-200 tw-font-bold tw-text-teal-600 tw-cursor-pointer"
      (click)="openLanguageChangeDrawer()" i18n="@@change">Change</span>
  </div>
  <!-- Normal state -->
  <div *ngIf="isAppLanguageEnglish && !languageUpdatedDisplayName"
       class="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3 tw-bg-white tw-rounded-b-[15px]">
    <span class="tw-text-300 tw-text-gray-500 tw-font-body" i18n="@@voiceNoteLanguage">Voice note language</span>
    <div class="tw-flex tw-items-center tw-gap-1 tw-h-7 tw-px-3 tw-border tw-border-solid tw-border-teal-600 tw-rounded-full"
         (click)="openLanguageChangeDrawer()">
      <span class="tw-font-body tw-text-200 tw-font-bold tw-text-teal-600">
        {{appConfig.Shared.LanguagesLong[currentCommunicationLanguageCode?.toUpperCase() || 'EN']}}
      </span>
      <em class="cs-icon-arrow tw-text-teal-600 tw-rotate-90 tw-text-[10px]"></em>
    </div>
  </div>
</ng-template>
